import script from "./forgotpassword-form-container.vue?vue&type=script&setup=true&lang=js"
export * from "./forgotpassword-form-container.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__